import { isValidEmail } from './member';

const { isEmptyObject } = require('utilities/common');

export function physicianFormValidation(fields) {
    const errors = {};
    if (!fields.email || !isValidEmail(fields.email)) {
        errors.email = 'Email is required';
    }

    if (!fields.firstName || fields.firstName.trim() === '') {
        errors.firstName = 'First name is required';
    }

    if (!fields.lastName || fields.lastName.trim() === '') {
        errors.lastName = 'Last name is required';
    }
  if (!fields.phone || fields.phone.trim() === '') {
        errors.phone = 'Phone number is required';
    }

    return { errors, isValid: isEmptyObject(errors) };
}